import * as components from '@/components';

export default async (componentName) => {
  let component = components[componentName];
  if (component instanceof Function || component instanceof Promise) {
    ({ default: component } = await component());
  }
  return component;
};
